import React from 'react'
import { Carousel, Testimonials } from '../components/services'
import { Banner, Connect } from '../components/common'
import { services, services__description } from '../i18n/text/data'

const Services = () => {

    return (
        <div className="page services">
            <div className="section align-center h80vh">
                <Banner size="banner__text--large">{services}</Banner>
            </div>
            <div className="section">
                <Carousel data={services__description} />            
            </div>
            <div className="section">
                <Testimonials />                
            </div>
            <div className="section">
                <Connect />            
            </div>
        </div>
    )
}

export default Services


